import React from "react";

export default function Title({ children }) {
  return (
    <h1 className="uppercase text-2xl md:text-3xl lg:text-6xl tracking-wide font-bold">
      {children}
    </h1>
  );
}
